import { render, staticRenderFns } from "./Goverment.vue?vue&type=template&id=494b2ebe&scoped=true&"
import script from "./Goverment.vue?vue&type=script&lang=js&"
export * from "./Goverment.vue?vue&type=script&lang=js&"
import style0 from "./Goverment.vue?vue&type=style&index=0&id=494b2ebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b2ebe",
  null
  
)

export default component.exports